import { Text } from '@vinted/web-ui'

import { Skeleton } from '@marketplace-web/common-components/skeleton-ui'

const BundleFooterPricingSkeleton = () => (
  <div className="u-flexbox u-flex-direction-column u-flex-none">
    <div className="u-flexbox u-flex-direction-row">
      <Text width={Text.Width.Parent} as="span" type={Text.Type.Subtitle}>
        <Skeleton height={12} width={50} />
      </Text>
    </div>
    <Text width={Text.Width.Parent} as="span" type={Text.Type.Subtitle}>
      <Skeleton height={12} width={90} />
    </Text>
  </div>
)

export default BundleFooterPricingSkeleton
